export default {"src":"/_next/static/media/download-file-icon.b4fc36a0.svg","height":16,"width":16};